import {baseUrl, buildAuthRequest, handleJsonResponse} from "./util/Common";

function findHubs() {
    return buildAuthRequest()
        .then((req) => {
            return fetch(`${baseUrl}/hubs`, req);
        })
        .then((res) => {
            return handleJsonResponse(res);
        });
}

function findHubById(hubId) {
    return buildAuthRequest()
        .then((req) => {
            return fetch(`${baseUrl}/hubs/${hubId}`, req);
        })
        .then((res) => {
            return handleJsonResponse(res);
        });
}

function updateHubById(hubId, {title = undefined}) {
    return buildAuthRequest(
        'PATCH',
        {'Content-Type': 'application/json'},
        JSON.stringify({
            title: title
        })
    ).then((req) => {
        return fetch(`${baseUrl}/hubs/${hubId}`, req);
    }).then((res) => {
        return handleJsonResponse(res);
    });
}

export {
    findHubs,
    findHubById,
    updateHubById
}